import { render, staticRenderFns } from "./bottomTools.vue?vue&type=template&id=10537e94&scoped=true&"
import script from "./bottomTools.vue?vue&type=script&lang=js&"
export * from "./bottomTools.vue?vue&type=script&lang=js&"
import style0 from "./bottomTools.vue?vue&type=style&index=0&id=10537e94&prod&lang=css&"
import style1 from "./bottomTools.vue?vue&type=style&index=1&id=10537e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10537e94",
  null
  
)

export default component.exports